module.exports = __webpack_public_path__ + "static/media/kelly-sikkema-tk9RQCq5eQo-unsplash.bfd4a238.jpg";